import type { Pricing } from '@/types/checkout';
import { formatTotalPrice } from '@/utils/pricing';
import { useTranslate } from '@/hooks/useTranslate';

export const TotalPrice = ({ pricing }: { pricing: Pricing }) => {
  const { t } = useTranslate();
  // Text color inherits from `<Details>` (auto-contrasted per BG presence).
  return (
    <div className="flex justify-between w-full text-md md:text-base font-bold">
      <div>{t('total')}</div>
      <div data-testid="price-total">{formatTotalPrice(pricing)}</div>
    </div>
  );
};
